import { render } from "./visitor-types.vue?vue&type=template&id=196f2aaf&scoped=true"
import script from "./visitor-types.vue?vue&type=script&lang=js"
export * from "./visitor-types.vue?vue&type=script&lang=js"

import "./visitor-types.vue?vue&type=style&index=0&id=196f2aaf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196f2aaf"]])

export default __exports__